import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { basketballConfig } from "~config/sport/basketball";
import { defaultsConfig } from "~config/sport/defaults";
import { footballConfig } from "~config/sport/football";
import { handballConfig } from "~config/sport/handball";
import { hockeyConfig } from "~config/sport/hockey";
import { ice3Config } from "~config/sport/ice3";
import { tennisConfig } from "~config/sport/tennis";
import { volleyballConfig } from "~config/sport/volleyball";
import type { SportConfiguration } from "~types/sportConfiguration";

const config: { [sport: string]: SportConfiguration } = {
  basketball: basketballConfig,
  handball: handballConfig,
  hockey: hockeyConfig,
  ice3: ice3Config,
  volleyball: volleyballConfig,
  tennis: tennisConfig,
  defaults: defaultsConfig,
  football: footballConfig,
};

export const useSportConfiguration = () => {
  const { sport: sportFromParams } = useParams();
  const sport = sportFromParams?.toLowerCase() ?? "";

  const sportConfig = config[sport];

  return isEmpty(sportConfig) ? config.defaults : sportConfig;
};
